import { Node, mergeAttributes } from "@tiptap/core";
import { renderDiagram } from "./renderDiagram";

// A worksheet diagram stored as data (its spec) and drawn as SVG, the same way
// mathInline stores LaTeX and draws it with KaTeX.
export const Diagram = Node.create({
  name: "diagram",
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      spec: {
        default: null,
        parseHTML: (element) => {
          try {
            return JSON.parse(element.getAttribute("data-diagram"));
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => ({ "data-diagram": JSON.stringify(attributes.spec) }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "div[data-diagram]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("div");
      dom.className = "diagram-node";
      dom.style.cssText = "margin: 8px 0 12px 24px;";
      const svg = renderDiagram(node.attrs.spec);
      if (svg) {
        dom.appendChild(svg);
      } else {
        dom.textContent = "[Diagram unavailable]";
        dom.style.color = "#8a8a8a";
        dom.style.fontStyle = "italic";
      }
      return { dom };
    };
  },
});
